import React from "react";
import s from './Preloader.module.css'


const Preloader = (props) => {
    return (
        <div className={s.gooey}>
            <span className={s.dot}></span>
            <div className={s.dots}>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    )
};


export default Preloader;